import { useSetAtom } from 'jotai'
import type { WalletConnectWalletClickedProperties } from '@/src/codegen/ampli'
import { useAmplitudeAnalytics } from '@/src/hooks/use-amplitude-analytics'
import {
  openSelectWalletsDialog,
  selectWalletsDialogAtom,
} from '@/src/stores/select-wallets'
import { cn } from '@/src/utils/styles'
import { Button } from './button'

interface ConnectWalletButtonProps {
  className?: string
  /**
   * The component from which this is getting rendered.
   *
   * For Amplitude purposes.
   */
  from: WalletConnectWalletClickedProperties['position']
}

export default function ConnectWalletButton({
  className,
  from,
}: ConnectWalletButtonProps) {
  const { ampli } = useAmplitudeAnalytics()
  const setDialogState = useSetAtom(selectWalletsDialogAtom)

  return (
    <Button
      data-testid='connect'
      type='button'
      variant='secondary'
      className={cn('rounded-[48px] hidden sm:block', className)}
      onClick={() => {
        ampli?.walletConnectWalletClicked({
          position: from,
        })
        setDialogState(openSelectWalletsDialog())
      }}
    >
      Connect
    </Button>
  )
}
